import React from 'react';
import { Link } from 'react-router-dom';
import classes from './Button.module.css';
import strings from '../../../assets/localization';

const button = (props) => {
  let style = props.style ? props.style : {};
  let classStyles = [classes.Button, classes[props.btnType]];
  if (props.width) {
    style = { ...style, width: props.width + '%' };
  }
  if (props.disabled === false && props.noScale) {
    classStyles = [classes.Button, classes[props.btnType]];
  } else if (props.disabled === false) {
    classStyles = [
      classes.Button,
      classes.EnableButtonAnimation,
      classes[props.btnType],
    ];
  }

  const accessibleName = props.ariaLabel || props.children || strings.clickHere;

  if (props.isLink) {
    return (
      <Link
        to={props.link}
        style={style}
        className={classStyles.join(' ')}
        disabled={props.disabled}
        aria-label={accessibleName}
      >
        {props.children}
      </Link>
    );
  } else {
    return (
      <button
        style={style}
        disabled={props.disabled}
        className={classStyles.join(' ')}
        onClick={props.clicked}
        aria-label={accessibleName}
      >
        {props.children}
      </button>
    );
  }
};

export default button;
